const en = {
  translation: {
    'Sign in credentials': 'Sign in credentials',
    'Sign in': 'Sign in',
    'Add Category': 'Add Category',
    Title: 'Title',
    Description: 'Description',
    Add: 'Add',
    Remove: 'Remove',
    'Add/Remove': 'Add/Remove',
    Success: 'Success',
    Danger: 'Danger',
    Categories: 'Categories',
    Image: 'Image',
    Header: 'Header',
    Loading: 'Loading',
    Error: 'Error',
    Edit: 'Edit',
    Delete: 'Delete',
    Visibility: 'Visibility',
    Visible: 'Visible',
    Hidden: 'Hidden',
    HideStore: 'Hide from customers',
    ShowStore: 'Show to customers',
    HideStoreHint: 'Click to hide this store from the app and website',
    ShowStoreHint: 'Hidden from customers. Click to show it again',
    ConfirmHideStore:
      'Hide {{name}} from customers? It disappears from the app and website until you show it again. The vendor can still sign in.',
    MorePhotos: 'More photos',
    AddPhotos: 'Add photos',
    MorePhotosHelp:
      'Shown as a swipeable gallery after the main image on the product page. Fashion & Beauty stores only.',
    GalleryLimit: 'You can add up to {{count}} extra photos.',
    DeleteSelected: 'Delete selected',
    ConfirmDeleteSelected:
      'Delete {{count}} selected item(s)? This cannot be undone.',
    'Edit Category': 'Edit Category',
    Save: 'Save',
    'OrderID prefix': 'OrderID prefix',
    Order: 'Order',
    Email: 'Email',
    Password: 'Password',
    Enable: 'Enable',
    Disable: 'Disable',
    'Enable/Disable': 'Enable/Disable',
    Saving: 'Saving',
    Paypal: 'Paypal',
    'Client ID': 'Client ID',
    'Client Secret': 'Client Secret',
    Sandbox: 'Sandbox',
    'Publishable Key': 'Publishable Key',
    'Secret Key': 'Secret Key',
    'Delivery Charges': 'Delivery Charges',
    Price: 'Price',
    'Add Food': 'Add Product',
    Category: 'Category',
    Select: 'Select',
    Variations: 'Variations',
    'Food Image': 'Product Image',
    Foods: 'Products',
    Actions: 'Actions',
    'Edit Food': 'Edit Product',
    OrderID: 'OrderID',
    Orders: 'Orders',
    Name: 'Name',
    Items: 'Items',
    Voucher: 'Voucher',
    ComingSoon: 'Coming Soon',
    StoreTypeHelp:
      'Decides which home screen tile this store appears under and the label on its card. Pick Other to type a custom label. Tiles are managed under Shop Types.',
    SelectStoreType: 'Select store type',
    OtherStoreType: 'Other…',
    OpeningSoon: 'Opening Soon',
    ShowComingSoonBanner: 'Show Coming Soon banner',
    OpeningSoonHelp:
      'While this is on, the store is listed in the apps with a Coming Soon banner. Customers can browse the menu but cannot place an order. Turn it off on launch day.',
    SearchOrderOrVoucher: 'Order ID or voucher',
    SearchOrderVoucherOrCustomer: 'Order ID, voucher, customer or product',
    Reporting: 'Reporting',
    ReportType: 'Report type',
    StoreReport: 'Store report',
    RiderReport: 'Rider report',
    SelectRestaurant: 'Select a store',
    SelectRider: 'Select a rider',
    Period: 'Period',
    ThisMonth: 'This month',
    LastMonth: 'Last month',
    GenerateReport: 'Generate report',
    GenerateReportHint: 'Choose a period and select Generate report.',
    DownloadPDF: 'Download PDF',
    InvoiceNo: 'Invoice no.',
    CompanyDetailsMissing: 'Set your company details in Configuration',
    TotalIncVAT: 'Total inc. VAT',
    Type: 'Type',
    Cash: 'Cash',
    Card: 'Card',
    From: 'From',
    To: 'To',
    Clear: 'Clear',
    Payment: 'Payment',
    Status: 'Status',
    Review: 'Review',
    'Mark as': 'Mark as',
    Users: 'Users',
    Phone: 'Phone',
    Address: 'Address',
    2019: '2019',
    'About Us': 'About Us',
    Blog: 'Blog',
    Welcome: 'Welcome',
    Logout: 'Logout',
    SubtitleInfluencerHome: 'Your coupon earnings and orders at a glance',
    SubtitleInfluencerOrders: 'Every order placed with one of your coupons',
    SubtitleInfluencerWallet: 'Your balance and withdrawal requests',
    SubtitleInfluencerProfile: 'Your contact details',
    SubtitleInfluencerBank: 'Where your payouts are sent',
    SubtitleInfluencerSettings: 'Keep your account secure',
    ProfilePhotoHint: 'Change your photo from the menu at the top right',
    AvailableToWithdraw: 'Available to withdraw',
    WithdrawAll: 'Withdraw all',
    DeleteInfluencerConfirm:
      'They will no longer be able to sign in, and their coupons stop earning. This cannot be undone.',
    InfluencerFormSubtitle:
      'Login details, commission and the coupons they promote',
    AccountDetails: 'Account details',
    CommissionAndCoupons: 'Commission & coupons',
    ChangePhoto: 'Change photo',
    UploadPhoto: 'Upload photo',
    PhotoUpdated: 'Profile photo updated',
    PhotoUploadFailed: 'Could not update photo. Try again.',
    Dashboard: 'Dashboard',
    Configuration: 'Configuration',
    Login: 'Login',
    Food: 'Products',
    'Character limit of max length 50': 'Character limit of max length 50',
    'Character limit of max length 15': 'Character limit of max length 15',
    'Character limit of max length 60': 'Character limit of max length 60',
    'Character limit of max length 20': 'Character limit of max length 20',
    'Character limit of max length 140': 'Character limit of max length 140',
    Currency: 'Currency',
    Delivery: 'Delivery',
    'Currency Code': 'Currency Code',
    'Delivery Rate': 'Delivery Rate',
    'Currency Symbol': 'Currency Symbol',
    enterYourDetailsBelow: 'Enter your details below',
    LogintoEnatega: 'Login to Borku',
    RememberMe: 'Remember me',
    ForgotYourPassword: 'Forgot your password?',
    errorWhileSaving: 'An error occured while saving,Try again',
    Saved: 'Saved',
    Addons: 'Addons',
    AddRemoveAddon: 'Add or Remove Addon',
    MinQuantity: 'Min quantity',
    MinimumQuantity: 'Minimum Quantity',
    MaxQuantity: 'Max quantity',
    MaximumQuantity: 'Maximum quantity',
    Options: 'Options',
    NewOption: 'New Option',
    RejectOrderTitle: 'Reject this order?',
    RejectOrderMessage:
      'Order {{id}} will be cancelled. This cannot be undone.',
    EditAddon: 'Edit addon',
    AddonFormSubtitle:
      'Group options customers can add to a product, like drinks or extra toppings.',
    Addon: 'Addon',
    RemoveAddon: 'Remove this addon',
    AddonDetails: 'Details',
    AddonTitlePlaceholder: 'e.g. Choose a drink',
    MinQuantityHint: '0 makes this addon optional',
    MaxQuantityHint: 'Most options a customer can pick',
    SelectedCount: '{{count}} selected',
    SelectOneOption: 'Select at least one option',
    NoOptionsYet: 'No options yet. Create one with "New Option".',
    Free: 'Free',
    AddAnotherAddon: 'Add another addon',
    CategoryUpdatedSuccessfully: 'Category updated successfully',
    CategoryAddedSuccessfully: 'Category added successfully',
    ActionFailedTryAgain: 'Action failed. Please Try again',
    PHCategory: 'Category i.e Breakfast',
    Emoji: 'Emoji',
    Optional: 'Optional',
    Preview: 'Preview',
    PHCategoryEmoji: 'Paste or pick an emoji i.e 🥐',
    PHFoodEmoji: 'Paste or pick an emoji i.e 🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    ChooseCurrency: 'Choose Currency',
    ChooseSymbol: 'Choose Symbol',
    PHMail: 'e.g something@email.com',
    EmailName: 'Email Name',
    PHEnatega: 'e.g Borku',
    PHFood: 'e.g FOOD',
    ClientSecretKey: 'Client Secret Key',
    Stripe: 'Stripe',
    PublishKey: 'Publish Key',
    CouponUpdated: 'Coupon updated',
    CouponAdded: 'Coupon Added',
    CuisineUpdated: 'Cuisine updated',
    CuisineAdded: 'Cuisine Added',
    Code: 'Code',
    PHCode: 'Code e.g SALE50',
    PHDiscount: 'Discount % i.e 1-100',
    PHDiscountFixed: 'Amount off in £, e.g. 100',
    FoodUpdatedSuccessfully: 'Product updated successfully',
    FoodAddedSuccessfully: 'Product added successfully',
    SelectCategory: 'Select Category',
    UploadAnImage: 'Upload an image',
    UniqueTitle: 'Title (must be unique)',
    Discounted: 'Discount Amount',
    DiscountedHelp:
      'How much is taken off. Customers pay the Price; the app shows Price + this amount struck through.',
    DiscountPreview: 'Shown as {{was}} → {{now}}',
    LoadingDots: 'Loading ...',
    NoRecordsFound: 'No records found',
    AddRating: 'Add rating',
    AddRatingHint:
      'Records a review against this store. It counts towards the store rating and appears in the app and website.',
    ReviewerNameRequired: 'A reviewer name is required.',
    InvalidEmail: 'Enter a valid email address.',
    NoRestaurantSelected: 'No store is selected.',
    RatingAdded: 'Rating added successfully.',
    AddedByAdmin: 'Added by admin',
    ErrorDots: 'Error ...',
    NewAddon: 'New Addon',
    EnategaMultivendor: 'Borku Multivendor',
    ResetPassword: 'Reset Password',
    EnategaDashboard: 'Borku Dashboard',
    UpdateOption: 'Update Option',
    AddOption: 'Add Option',
    OrderStatusUpdated: 'Order status updated',
    SpecialInstructions: 'Special Instructions',
    Charges: 'Charges',
    Subtotal: 'Subtotal',
    DeliveryFee: 'Delivery Fee',
    TaxCharges: 'Service Fee',
    Tip: 'Tip',
    Total: 'Total',
    PaymentMethod: 'Payment Method',
    PaymentStatus: 'Payment Status',
    PaidAmount: 'PaidAmount',
    Accepted: 'Accepted',
    Accept: 'Accept',
    PreparationTime: 'Preparation time',
    PreparationTimeHelp:
      'How long will the store take to prepare this order? The customer sees this countdown in the app.',
    CustomMinutes: 'Or enter minutes',
    min: 'min',
    Cancelled: 'Cancelled',
    Cancel: 'Cancel',
    DeleteConfirm: 'Are you sure you want to delete this item?',
    PHReasonIfRejected: 'Reason if Rejected',
    Datetime: 'Datetime',
    PasswordChangedSuccessfully: 'Password Changed successfully',
    ConfirmPassword: 'Confirm Password',
    Reset: 'Reset',
    RestaurantAdded: 'Store added',
    NetworkError: 'Network error',
    FieldsRequired: 'Fields Required',
    Username: 'Username',
    RestaurantUsername: "Store's username",
    RestaurantPassword: "Store's password",
    RestaurantName: "Store's name",
    RestaurantAddress: "Store's address",
    RestaurantPhone: "Store's phone",
    'Website URL': 'Website URL',
    RestaurantWebURL: "Store's website URL",
    'Bag Fee': 'Bag Fee',
    StoreCharges: 'Store Charges',
    DeliveryRatePerKm: 'Delivery Rate (per km)',
    DistanceCharges: 'Distance Charges',
    FixedAfterDistance: 'Fixed fee after distance (km)',
    FixedAfterDistancePlaceholder: 'e.g. 20',
    FixedAfterDistanceFee: 'Fixed delivery fee',
    FixedAfterDistanceNotice: 'Far distance note',
    FixedAfterDistanceHelp:
      'Past this distance the per-km rate stops and the fixed fee below is charged instead. Leave at 0 to turn this off.',
    FixedAfterDistanceNoticeHelp:
      'Shown to the customer at checkout when the fixed fee applies.',
    FixedAfterDistanceFeeRequired:
      'Set a fixed delivery fee greater than 0 for the distance you entered.',
    Loyalty: 'Loyalty',
    Referral: 'Referral',
    ReferralProgramme: 'Referral Programme',
    ReferralCredits: 'Credits per referral',
    ReferralCreditsHelp:
      'Credits the referrer earns once the person they invited completes their first order.',
    LoyaltyProgramme: 'Loyalty Programme',
    CreditsPerPound: 'Credits per 1 currency unit',
    CreditsPerPoundSharedHelp:
      'How many credits redeem for one unit of currency. Shared with the loyalty programme.',
    ReferralWorth:
      '{{credits}} credits = {{currencySymbol}}{{amount}} per completed referral.',
    CreditsPerPoundHelp:
      'How many credits a customer redeems for one unit of currency in their wallet.',
    CreditsPerPoundRequired: 'Credits per 1 currency unit must be more than 0',
    LoyaltyTiers: 'Order reward tiers',
    LoyaltyTiersHelp:
      "Credits earned on every order after the customer's first one. The highest tier the order total clears is awarded.",
    TierOrderFrom: 'Order total from',
    TierCredits: 'Credits',
    AddTier: 'Add another tier',
    'Configuration saved': 'Configuration saved',
    FreeDeliveryVoucherEnabled: 'Also attach a voucher to free delivery',
    FreeDeliveryCoupon: 'Free delivery voucher code',
    VoucherCodePlaceholder: 'e.g. FREEDEL',
    VoucherTotalUses: 'Total uses allowed',
    VoucherCreateHelp:
      'This voucher will be created when you save, and customers can then apply it at checkout.',
    VoucherExistsHelp:
      'This code already exists as a coupon. Saving will re-enable it and update its usage limit, leaving any existing discount on it untouched.',
    VoucherCodeRequired: 'Enter a voucher code, or turn the voucher off.',
    SelectCoupon: 'Select a coupon',
    FreeDeliveryCouponHelp:
      'Customers who apply this voucher at checkout also get free delivery, on top of anyone who already qualifies through the order amount and distance rules above.',
    RestaurantBagFee: "Store's bag fee",
    DeliveryTime: 'Delivery Time',
    DeliveryType: 'Delivery Type',
    DeliveryTypeInstant: 'Instant (same day)',
    DeliveryTypeScheduled: 'Not instant (takes days)',
    DeliveryTypeHelp:
      'Instant stores quote a delivery time in minutes. Not instant stores quote the number of days an order takes.',
    DeliveryDays: 'Delivery in (days)',
    PHDeliveryDays: 'e.g 3',
    DeliveryDaysHelp: 'How many days an order from this store takes to arrive.',
    MinOrder: 'Min Order',
    SalesTax: 'Sales Tax',
    ServiceFee: 'Service Fee',
    PaymentToStore: 'Payment to the store',
    ScheduleReports: 'Scheduled reports',
    PartialRefunds: 'Partial refunds',
    PartialRefundsHelp:
      'Record a refund you have already issued to the customer in Stripe (e.g. an item the store could not supply). It is taken off the order in the store report for the month the order was placed.',
    RecordRefund: 'Record refund',
    FindOrder: 'Find order',
    RefundAmount: 'Refund amount',
    RefundReason: 'Reason',
    RefundReasonPlaceholder: 'e.g. 1 item unavailable',
    RefundRecorded: 'Refund recorded.',
    RefundOrderNotFound: 'No order found with that ID.',
    Refunded: 'Refunded',
    NetPaid: 'Net paid',
    Refund: 'Refund',
    NetTotal: 'Net',
    RecordedBy: 'Recorded by',
    RemoveRefund: 'Remove refund',
    RemoveRefundConfirm:
      'This only removes the record from Borku reports. It does not reverse the refund in Stripe.',
    NoRefundsFound: 'No partial refunds recorded for this period.',
    ScheduleReportsHelp:
      'Pick a store and when its invoice should be generated and emailed. Invoices always cover the last complete period.',
    ScheduleRecipientNote:
      'Invoices are sent to the receiver email. Leave it blank to use the email on the store owner account.',
    ReceiverEmail: 'Receiver email',
    ReceiverEmailPlaceholder: 'Defaults to store owner email',
    Receiver: 'Receiver',
    OwnerEmail: 'Store owner email',
    ScheduleSaved: 'Schedule saved.',
    SaveSchedule: 'Save schedule',
    ActiveSchedules: 'Active schedules',
    NoSchedulesYet: 'No schedules yet.',
    RecentSends: 'Recent sends',
    NoSendsYet: 'Nothing sent yet.',
    SendNow: 'Send now',
    InvoiceSentTo: 'Invoice sent to',
    InvoiceNotSent: 'Invoice was not sent.',
    Frequency: 'Frequency',
    Monthly: 'Monthly',
    Weekly: 'Weekly',
    DayOfMonth: 'Day of month',
    DayOfWeek: 'Day of week',
    Day: 'Day',
    Time: 'Time',
    Enabled: 'Enabled',
    Paused: 'Paused',
    LastSent: 'Last sent',
    Recipient: 'Recipient',
    Period: 'Period',
    Sent: 'Sent',
    SalesForPeriod: 'Sales for the period',
    TotalChargedToCustomers: 'Total charged to customers',
    LessBorkuFee: 'Less Borku fee',
    YourSales: 'Your sales for the period',
    BorkuFeeCovers:
      'Borku fee covers commission, service fees, delivery charges and low-order fees.',
    LessCreditsApplied: 'Less Borku credits applied:',
    LessCommission: 'Less commission',
    TotalPaidToStore: 'Total paid to the store',
    PaidByBorkuCredit: 'of which paid by Borku credit',
    BorkuToSettle: 'Borku to pay the store directly',
    BorkuToSettleHelp:
      'Orders paid with Borku credits take no card payment, so this part of the payout cannot be transferred automatically and must be paid to the store directly. Excludes delivery, service fees and tips.',
    PaymentToStoreHelp:
      'Excludes delivery, service fees and tips, which are not paid to the store.',
    ServiceFeeType: 'Service Fee Type',
    ServiceFeePercentage: 'Percentage of order',
    ServiceFeeFixed: 'Fixed amount',
    ServiceFeePercentageHelp:
      'The fee is worked out as a percentage of the order, kept between the minimum and maximum below.',
    ServiceFeeFixedHelp:
      'The same fee is charged on every order, whatever it comes to.',
    ServiceFeePercent: 'Service Fee (%)',
    ServiceFeeAmount: 'Service Fee (amount)',
    ServiceFeeMin: 'Minimum service fee',
    ServiceFeeMinHelp:
      'The fee never falls below this. A £6 order at 10% would come to £0.60, so a minimum of £1 charges £1 instead.',
    ServiceFeeMax: 'Maximum service fee',
    ServiceFeeMaxHelp: 'The fee never rises above this. 0 means no ceiling.',
    RiderUpdatedSuccessfully: 'Rider updated successfully',
    RiderAddedSuccessfully: 'Rider added successfully',
    EditRider: 'Edit Rider',
    UsernameCannotBeBlank: "Username can't be blank",
    UsernameCannotContainSpaces: "Username can't contain spaces",
    AddRider: 'Add Rider',
    Staff: 'Staff',
    StaffUpdatedSuccessfully: 'Staff updated successfully',
    StaffAddedSuccessfully: 'Staff added successfully',
    Permissions: 'Permissions',
    Available: 'Available',
    PHRiderName: 'Rider name',
    Number: 'Number',
    PhoneNumber: 'Phone Number',
    RiderZone: 'Rider Zone',
    SectionUpdatedSuccessfully: 'Section updated successfully',
    SectionAddedSuccessfully: 'Section added successfully',
    EditSection: 'Edit Section',
    AddSection: 'Add Section',
    SectionName: 'Section Name',
    Update: 'Update',
    SubtitleHome: 'A clear view of your marketplace, all in one place.',
    SubtitleOverview: 'A clear view of your marketplace, all in one place.',
    DeliveredInRange: 'Delivered · selected range',
    DashEarned: 'Earned',
    DashSuccessfulOrders: 'Successful orders',
    DashAvgOrderValue: 'Avg. order value',
    DashCancelledOrders: 'Cancelled orders',
    DashVsPrevious: 'prev. period',
    DashCompletionRate: 'Completion rate',
    DashInProgress: '{{count}} still in progress',
    DashCustomers: 'Customers',
    DashNewReturning: '{{fresh}} new · {{returning}} returning',
    DashAvgPrepTime: 'Avg. prep time',
    DashAvgAcceptTime: 'Accept',
    DashRating: 'Rating',
    DashBasedOnReviews: 'Based on {{count}} reviews',
    DashTopItems: 'Top items',
    DashItemsSold: '{{count}} items sold',
    DashNoItems: 'Nothing sold in this range yet',
    SalesAndOrders: 'Sales & orders',
    AddFood: 'Add product',
    AddAddon: 'Add addon',
    AccountAccess: 'Account access',
    ProfileAccountHelp: 'Login used to sign in to this store.',
    StoreDetails: 'Store details',
    ProfileStoreDetailsHelp: 'What customers see on your store page.',
    DeliveryAndPricing: 'Delivery & pricing',
    ProfileDeliveryHelp: 'Fees, minimum order and how you deliver.',
    AdminSettings: 'Admin settings',
    ProfileAdminHelp: 'Only visible to Borku admins.',
    ProfileSaveHint: 'Changes are saved when you press Save.',
    TimingsHelp: 'Set the hours customers can order from you each day.',
    AddTimeSlot: 'Add slot',
    StripePayouts: 'Stripe payouts',
    StripePayoutsHelp: 'Connect Stripe to receive your card payouts.',
    StripeNotConnected: 'Stripe is not connected yet',
    StripeNotConnectedHelp: 'Connect an account to start receiving payouts.',
    StripeConnectedHelp: 'Payouts go to the connected Stripe account.',
    HowItWorks: 'How it works',
    StripeStepAccount: 'Create or sign in to your Stripe account',
    StripeStepBank: 'Add the bank account for payouts',
    StripeStepPayouts: 'Receive card payments automatically',
    OnTheWay: 'On the way',
    AverageRating: 'Average rating',
    TotalReviews: 'Total reviews',
    FiveStarReviews: '5-star reviews',
    LowRatings: 'Low ratings (≤2)',
    LocationHintMarker:
      'Click the map to place your store pin. Drag it to adjust, right-click to remove.',
    LocationHintPolygon:
      'Click the map to draw your delivery area. Drag points to adjust, right-click to remove.',
    Selected: 'selected',
    SearchStores: 'Search stores...',
    NoStoresMatch: 'No stores match your search.',
    Unavailable: 'Unavailable',
    Banner: 'Banner',
    Cuisine: 'Cuisine',
    Section: 'Section',
    Spotlight: 'Spotlight',
    VendorStores: 'Vendor stores',
    VendorStoresHelp: 'Stores that belong to this vendor.',
    StoreSingular: 'store',
    NoStoresYet: 'No stores yet',
    NoStoresYetHelp:
      'This vendor account is ready. Create its first store to start adding a menu, opening hours and delivery settings.',
    NoStoresStepDetails: 'Add store details',
    NoStoresStepMenu: 'Build the menu',
    NoStoresStepLive: 'Go live',
    SubtitleDashboard: 'A clear view of your store, all in one place.',
    SubtitleVendors: 'Manage vendor accounts and their stores.',
    SubtitleRestaurants: 'Manage your stores and vendor access in one place.',
    SubtitleOrders: 'Track and manage incoming orders.',
    SubtitleReporting: 'Sales and order reports across the marketplace.',
    SubtitleRestaurantSections:
      'Group stores into sections shown to customers.',
    SubtitleUsers: 'Customer accounts registered on the marketplace.',
    SubtitleRiders: 'Manage delivery riders and their zones.',
    SubtitleStaff: 'Team members and what they are allowed to access.',
    SubtitleCustomerSupport: 'Support tickets raised by customers and vendors.',
    SubtitleConfiguration: 'Marketplace-wide settings and integrations.',
    SubtitleInfluencers: 'Manage influencer accounts and their campaigns.',
    SubtitleCoupons: 'Discount codes customers can apply at checkout.',
    SubtitleCuisines: 'Cuisine types used to categorise stores.',
    SubtitleShopTypes: 'Store categories shown across the marketplace.',
    SubtitleZoneSpotlight: 'Feature selected stores within a delivery zone.',
    SubtitleRestaurantAds: 'Promotional banners shown in the customer app.',
    SubtitleTipping: 'Preset tip amounts offered at checkout.',
    SubtitleZone: 'Delivery zones and the areas they cover.',
    SubtitleDispatch: 'Assign live orders to available riders.',
    SubtitleCourier: 'Cross-zone courier orders and their carriers.',
    SubtitleNotifications: 'Send push notifications to customers.',
    SubtitleCommissionRates: 'Commission charged per store.',
    SubtitleWithdrawRequests: 'Payout requests from vendors and riders.',
    SubtitleLoyalty: 'Loyalty points earned and redeemed by customers.',
    SubtitleReferral: 'Referral rewards and their settings.',
    SubtitleProfile: 'Your store profile and public details.',
    SubtitleFood: 'Items on your menu and their pricing.',
    SubtitleCategory: 'Menu categories used to group your items.',
    SubtitleOption: 'Options customers can pick when ordering.',
    SubtitleAddons: 'Add-on groups attached to your menu items.',
    SubtitleRatings: 'Reviews and ratings left by customers.',
    SubtitleTimings: 'Opening hours for each day of the week.',
    SubtitlePayment: 'Payment methods accepted by your store.',
    SubtitleLocation: 'Delivery bounds and your store location.',
    SubtitleMarketing: 'Promote your store to customers.',
    WORKSPACE: 'WORKSPACE',
    Close: 'Close',
    Unassigned: 'Unassigned',
    RecentOrders: 'Recent orders',
    ViewAllOrders: 'View all orders',
    GENERAL: 'GENERAL',
    MANAGEMENT: 'MANAGEMENT',
    RESTAURANT: 'RESTAURANT',
    BackToAdmin: 'Back to Admin',
    Search: 'Search',
    TippingUpdated: 'Tipping updated',
    EditTipping: 'Edit Tipping',
    AddTipping: 'Add Tipping',
    Tip1: 'Tip 1',
    Tip2: 'Tip 2',
    Tip3: 'Tip 3',
    PHTip1: 'Tip 1 e.g 10',
    PHTip2: 'Tip 2 e.g 20',
    PHTip3: 'Tip 3 e.g 30',
    EditVendor: 'Edit Vendor',
    AddVendor: 'Add Vendor',
    PHNumber: 'e.g 123',
    ZoneUpdatedSuccessfully: 'Zone updated successfully',
    ZoneAddedSuccessfully: 'Zone added successfully',
    SetZoneOnMap: 'Set Zone on Map',
    EditZone: 'Edit Zone',
    AddZone: 'Add Zone',
    Minimum: 'Minimum',
    Maximum: 'Maximum',
    Action: 'Action',
    AvailableAfterPurchasing:
      'This feature will available after purchasing product',
    CommissionRates: 'Commission Rates',
    PHCommission: 'Commission percent',
    Discount: 'Discount',
    'Discount Type': 'Discount Type',
    'Free Delivery Settings': 'Free Delivery Settings',
    'Minimum Order': 'Minimum Order',
    'Minimum Order Amount': 'Minimum Order Amount',
    'Free Delivery Limit': 'Free Delivery Limit',
    'Distance Limit': 'Distance Limit',
    'The minimum total an order must reach to qualify for free delivery.':
      'The minimum total an order must reach to qualify for free delivery.',
    'The number of free deliveries available. This value decreases with each order and will automatically disable free delivery when it reaches zero.':
      'The number of free deliveries available. This value decreases with each order and will automatically disable free delivery when it reaches zero.',
    'The maximum delivery distance (in km) eligible for free delivery.':
      'The maximum delivery distance (in km) eligible for free delivery.',
    'Universal unique code for the coupon':
      'Universal unique code for the coupon',
    'Select if the discount is a percentage or a fixed amount':
      'Select if the discount is a percentage or a fixed amount',
    'The value of the discount': 'The value of the discount',
    FreeDeliveryUpdated: 'Free Delivery settings updated successfully',
    Coupons: 'Coupons',
    Cuisines: 'Cuisines',
    StartDate: 'Start Date',
    GraphFilter: 'Graph Filter',
    EndDate: 'End Date',
    Apply: 'Apply',
    UpdatingLocationError:
      'An error occurred while updating location and bounds',
    LocationMarkerRequired: 'Location marker is required',
    DeliveryAreaRequired: 'Delivery area is required',
    LocationUpdatedSuccessfully: 'Location and bounds updated successfully',
    SetLocation: 'Set Location',
    DrawDeliveryBounds: 'Draw Delivery Bounds',
    SetRestaurantLocation: 'Set Store Location',
    RemoveDeliveryBounds: 'Remove Delivery Bounds',
    RemoveRestaurantLocation: 'Remove Store Location',
    Reject: 'Reject',
    Delivered: 'Delivered',
    OrderInformation: 'Order Information',
    RestaurantCol: 'Store',
    StoreCol: 'Store',
    Rider: 'Rider',
    StoreNote: 'Store note',
    RiderNote: 'Rider note',
    Remaining: 'Remaining',
    AcceptedAt: 'Accepted',
    PrepTime: 'Prep time',
    Ready: 'Due',
    Overdue: 'Overdue',
    ImageTypeNotSupported:
      'That file type is not supported. Use JPG, PNG, GIF, WEBP or SVG.',
    ImageUploadFailed: 'Image upload failed. The product was not saved.',
    ImageUploadNotConfigured:
      'Image uploading is not configured. Contact an administrator.',
    ImageReadFailed: 'That image could not be read. Try another file.',
    ProductDetails: 'Product details',
    PHProductDetails: 'Pre-cut Lace, Time Saver & Beginner Friendly',
    ProductDetailsHelp:
      'Shown as a bulleted feature list on the product page. Write one feature per line.',
    OrderTime: 'Order time',
    Dispatch: 'Dispatch',
    PasswordUpdated: 'Password has been updated',
    ForgotPassword: 'Forgot Password',
    NotificationSentAuccessfully: 'Notification sent successfully',
    Notifications: 'Notifications',
    AllMarketplaceActivity: 'All marketplace activity',
    ActivityForThisStore: 'Activity for this store',
    MarkAllAsRead: 'Mark all as read',
    NewOrderSoundOn: 'New-order sound is on - click to mute',
    NewOrderSoundOff: 'New-order sound is muted - click to turn on',
    ClearAll: 'Clear all',
    NoNotificationsYet: 'No notifications yet',
    SelectStoreToSeeNotifications: 'Select a store to see its notifications',
    JustNow: 'just now',
    Body: 'Body',
    Zones: 'Zones',
    RequestID: 'Request ID',
    Amount: 'Amount',
    Date: 'Date',
    REQUESTED: 'REQUESTED',
    TRANSFERRED: 'TRANSFERRED',
    CANCELLEDStatus: 'CANCELLED',
    WithdrawRequests: 'Withdraw Requests',
    TotalRestaurants: 'Total Stores',
    Restaurants: 'Stores',
    Vendors: 'Vendors',
    RestaurantUpdatedSuccessfully: 'Store updated successfully',
    UpdateProfile: 'Update Profile',
    PHRestaurantPassword: "Store's password",
    PHRestaurantName: "Store's name",
    PHRestaurantAddress: "Store's address",
    OrderPrefix: 'Order Prefix',
    Days: 'Days',
    OpenTimes: 'Open Times',
    TimeSavedSuccessfully: 'Time saved successfully',
    ErrorWhileSavingTime: 'Error while saving time',
    SavingDots: 'Saving...',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    MainPageText: 'A cross-plalform software',
    MainPageText1:
      'A full fledged solution highly suitable to build any store.',
    ViewSite: 'View Site',
    TotalUsers: 'Total Users',
    TotalVendors: 'Total Vendors',
    TotalRiders: 'Total Riders',
    RestaurantSections: 'Store Sections',
    ImageMenu: 'image menu',
    Vendor: 'Vendor',
    AddNewRestaurant: 'Add New Store',
    Ratings: 'Ratings',
    StripeDetailsAttached: 'Stripe Details Attached',
    EditStripeDetails: 'Edit Stripe details',
    SubmitStripeDetails: 'Submit Stripe details',
    'Restaurant Sections': 'Store Sections',
    'Restaurant Ads': 'Store Ads',
    NoImageYet: 'No image yet',
    AddonPickOptional: 'Optional',
    AddonPickExactly: 'Customer must choose {{count}}',
    AddonPickUpTo: 'Optional · customer can choose up to {{count}}',
    AddonPickRange: 'Customer must choose {{min}} to {{max}}',
    UnitMinutes: 'min',
    UnitDays: 'days',
    UnitHours: 'hours',
    UnitMinutesLong: 'minutes',
    CourierDeliveryTime: 'Delivery time to other cities',
    CourierDeliveryTimeHelp:
      "Shown on the store card to customers outside this store's zone (courier delivery), e.g. 2 days. Leave empty to show the normal delivery time.",
    UnitPerKm: '/ km',
    StoreTypeLabel: 'Store Type',
    PHStoreType: 'e.g. Grocery, Bakery, Pizza',
    HygieneRating: 'Hygiene Rating',
    PHHygieneRating: 'Link to the hygiene rating page',
    BagFeeHelp: 'Added to every order that needs a carrier bag.',
    MinOrderHelp:
      'Smallest basket subtotal a customer can check out with. 0 means no minimum.',
    DeliveryTimeHelp:
      'Typical minutes from order to doorstep, shown on the store page.',
    OrderPrefixHelp:
      "Put in front of this store's order numbers so orders are easy to tell apart.",
    DeliveryRateHelp:
      'Charged for each km (rounded up) between the store and the customer, beyond the flat-fee distance.',
    HygieneRatingHelp: 'Optional link shown to customers on the store page.',
    Riders: 'Riders',
    Influencers: 'Influencers',
    AddInfluencer: 'Add Influencer',
    EditInfluencer: 'Edit Influencer',
    InfluencerName: 'Influencer name',
    RatePerOrder: 'Rate per order',
    TotalEarnings: 'Total earnings',
    Enabled: 'Enabled',
    SelectCoupons: 'Select coupons',
    ActiveOrders: 'Active orders',
    ActiveOrdersHelp: 'Placed with your coupon, not yet completed',
    PendingCompletion: 'Pending completion',
    Paid: 'Paid',
    PeriodEarnings: 'Earnings in period',
    PeriodEarningsHelp: 'Paid orders within the selected dates',
    PeriodOrders: 'Orders in period',
    BankDetails: 'Bank details',
    BankDetailsHelp:
      'Payouts are sent to this account. A withdrawal cannot be requested without an account number and sort code.',
    AccountHolderName: 'Account holder name',
    BankName: 'Bank name',
    AccountNumber: 'Account number',
    SortCode: 'Sort code',
    SortCodePlaceholder: '00-00-00',
    PayTo: 'Pay to',
    NoBankDetails: 'No bank details',
    RaisingOnBehalf:
      'You are raising this request on behalf of this influencer.',
    Earnings: 'Earnings',
    ViewDashboard: 'View dashboard',
    InfluencerDashboard: 'Influencer dashboard',
    BackToInfluencers: 'Back to influencers',
    Overview: 'Overview',
    Coupon: 'Coupon',
    UsersUsed: 'Users used',
    Yes: 'Yes',
    No: 'No',
    Wallet: 'Wallet',
    WalletBalance: 'Wallet balance',
    Withdrawn: 'Withdrawn',
    PickupOrders: 'Pickup orders',
    DeliveryOrders: 'Delivery orders',
    MyCoupons: 'My Coupons',
    NoCouponsAssigned: 'No coupons assigned yet',
    OrderType: 'Order type',
    Pickup: 'Pickup',
    OrderAmount: 'Order amount',
    Earning: 'Earning',
    MyOrders: 'My Orders',
    NoOrdersYet: 'No orders yet',
    RequestWithdraw: 'Request a withdrawal',
    Request: 'Request',
    WithdrawRequestSubmitted: 'Withdraw request submitted',
    EnterValidAmount: 'Enter an amount greater than zero',
    NotEnoughBalance: 'Not enough balance in your wallet',
    NoWithdrawRequests: 'No withdraw requests yet',
    MyProfile: 'My Profile',
    ProfileUpdated: 'Profile updated',
    NameRequired: 'Name is required',
    ChangePassword: 'Change password',
    NewPassword: 'New password',
    PasswordTooShort: 'Password must be at least 6 characters',
    PasswordsDoNotMatch: 'Passwords do not match',
    RequestedBy: 'Requested By',
    RequesterType: 'Type',
    Influencer: 'Influencer',
    EmailLogin: 'Email (login)',
    InfluencerAddedSuccessfully: 'Influencer added successfully',
    InfluencerUpdatedSuccessfully: 'Influencer updated successfully',
    Tipping: 'Tipping',
    Zone: 'Zone',
    'Commission Rates': 'Commission Rates',
    'Withdraw Requests': 'Withdraw Requests',
    Home: 'Home',
    Profile: 'Profile',
    Option: 'Option',
    Timings: 'Timings',
    Location: 'Location',
    'Back to Admin': 'Back to Admin',
    TotalOrders: 'Total Orders',
    TotalSales: 'Total Sales',
    ClosedAllDay: 'Closed All Day',
    AddRestaurant: 'Add Store',
    EditCoupon: 'Edit Coupon',
    AddCoupon: 'Add Coupon',
    AddFreeDeliveryVoucher: 'Add free delivery voucher',
    EditFreeDeliveryVoucher: 'Edit free delivery voucher',
    FreeDeliveryVouchers: 'Free delivery vouchers',
    NoFreeDeliveryVouchers:
      'No free delivery vouchers yet. Add one to hand out discounted or free delivery, e.g. for university students.',
    DeliveryFeeDiscount: 'Delivery fee discount',
    DeliveryFeeDiscountPercent: 'Delivery fee discount (%)',
    DeliveryFeeDiscountHelp:
      'Percentage taken off the delivery fee only. 100% makes delivery free.',
    FreeDeliveryLabel: 'FREE delivery',
    OffDelivery: 'off delivery',
    TooFarForFreeDeliveryNote: 'Too far for free delivery note',
    TooFarForFreeDeliveryNoteHelp:
      'Shown at checkout when the customer is outside the free delivery distance limit. Leave blank to use the default wording.',
    TooFarForFreeDeliveryDefault:
      'You are too far away for free delivery, so the standard delivery fee applies.',
    FreeDeliveryOverridesDistance:
      'When free delivery applies, it overrides this charge.',
    EditCuisine: 'Edit Cuisine',
    AddCuisine: 'Add Cuisine',
    'Shop Types': 'Shop Types',
    ShopTypes: 'Shop Types',
    EditShopType: 'Edit Shop Type',
    AddShopType: 'Add Shop Type',
    ShopTypeUpdated: 'Shop type updated',
    ShopTypeAdded: 'Shop type added',
    CuisineImageHelp:
      'Shown in the "Explore your options" row on the home screen. Square image, at least 400x400. Leave empty to use the emoji instead.',
    PHCuisineEmoji: 'e.g 🍚',
    'Zone Spotlight': 'Zone Spotlight',
    ZoneSpotlight: 'Zone Spotlight',
    EditZoneSpotlight: 'Edit Zone Spotlight',
    LoadingSpotlight: 'Loading the saved spotlight...',
    ZoneSpotlights: 'Zone Spotlights',
    ZoneSpotlightHelp:
      'Pin stores to the top of the home screen for customers ordering inside a zone. Drag to set the order they appear in.',
    ZoneSpotlightSaved: 'Zone spotlight saved',
    SelectZone: 'Select a zone',
    SelectZoneToStart: 'Select a zone to start pinning stores.',
    SelectStore: 'Select a store',
    AddStore: 'Add store',
    NoStoresPinned: 'No stores pinned yet. Add one above.',
    UseCurrentListing: 'Use current listing',
    StartEmptyList: 'Start empty',
    EditingSavedOrder: 'Editing the saved order the app is serving.',
    EditingCurrentListing:
      'Prefilled with the listing the app shows today. Reorder it and save to pin it.',
    RailTitle: 'Rail title',
    PHRailTitle: 'e.g Featured near you',
    Stores: 'Stores',
    AllShopTypes: 'All shop types',
    StoreTagline: 'Store tagline',
    PHStoreTagline: 'e.g Fresh bakery since 1998',
    StoreTaglineHelp:
      'A short line shown under the store name in the app and on the web. Leave empty to hide it.',
    PromoMessage: 'Promotional messages',
    AddPromoMessage: 'Add another message',
    ShowPromoMessage: 'Show on store page',
    PHPromoMessage: 'e.g 25% off selected items',
    PromoMessageHelp:
      'Shown as cards at the top of this store page in the app, above the first category. Up to 5, swiped sideways. Leave the switch off to hide them.',
    Icon: 'Icon',
    Slug: 'Slug',
    PHShopTypeSlug: 'e.g pharmacy',
    ShopTypeSlugHelp:
      'Used to match stores, so it is always lowercase with hyphens instead of spaces and punctuation. The customer-facing wording is the Name above.',
    ShopTypeSlugPreview: 'Will be saved as:',
    ShopTypeDescriptionHelp:
      'Shown in the "Coming Soon" banner while this section has no stores yet. Leave empty to use the default message.',
    ShopTypeImageHelp:
      'Shown large on the home screen. Use a square image of at least 600x600, ideally a PNG with a transparent background. Up to 5MB.',
    DisplayOrder: 'Display Order',
    HomeLayout: 'Store Page Layout',
    StorePageLayout: 'Store Page Layout',
    StorePageLayoutHelp:
      'Overrides the layout set on the shop type for this store only.',
    LayoutFollowShopType: 'Follow shop type',
    CategoryImageHelp:
      'Shown on the category cards when the store page uses the category grid layout.',
    DeleteCategoryConfirm:
      'Delete "{{title}}"? The products in this category will no longer be shown in the app.',
    VariantRow: 'Variant 1 — Product list',
    VariantRowHelp:
      'Products fill the width, one per row, with the image on the right. Best for menus.',
    VariantGrid: 'Variant 2 — Product grid',
    VariantGridHelp:
      'Products show as image-first tiles, two per row. Best for shops with many products.',
    ImageUrl: 'Image URL',
    PHShopTypeImage: 'https://...',
    PHShopTypeEmoji: 'Paste or pick an emoji i.e 💊',
    SalesAmount: 'Sales Amount',
    OrderCount: 'Order Count',
    MON: 'MON',
    TUE: 'TUE',
    WED: 'WED',
    THU: 'THU',
    FRI: 'FRI',
    SAT: 'SAT',
    SUN: 'SUN',
    Open: 'Open',
    ACCEPTED: 'ACCEPTED',
    PENDING: 'PENDING',
    PICKED: 'PICKED',
    ASSIGNED: 'ASSIGNED',
    DELIVERED: 'DELIVERED',
    REJECTED: 'REJECTED',
    Courier: 'Courier',
    CourierStatus: 'Courier status',
    CourierDetails: 'Courier details',
    Carrier: 'Carrier',
    TrackingNumber: 'Tracking number',
    EstimatedDelivery: 'Estimated delivery',
    LastUpdated: 'Last updated',
    Customer: 'Customer',
    CreatedAt: 'Created at',
    DeliveryAddress: 'Delivery address',
    AllStatuses: 'All statuses',
    NoCourierOrders: 'No courier orders',
    SendToRiders: 'Send to riders',
    SendToRidersHelp:
      'Turn this into a normal order — every rider, in any zone, will see it and can pick it up.',
    Country: 'Country',
    SelectCountry: 'Select country',
    CountryWideDelivery: 'Deliver to entire country',
    CountryWideDeliveryHelp:
      'Sell across every zone of the store’s country. Cross-zone orders go to an external courier instead of our riders. Leave the country blank to auto-detect it from the store’s zone.',
    CountryWideDeliveryAutoNote:
      'Country is auto-detected from the store’s zone on save — set it here only to override.',
    'Customer Marketing': 'Customer Marketing',
    SubtitleCustomerMarketing:
      'Who your customers are, where they order from and who to win back.',
    TotalCustomers: 'Total customers',
    NewCustomers: 'New customers',
    OrderedInPeriod: 'Ordered',
    FirstTimeOrderers: 'First-time orderers',
    NeverOrdered: 'Never ordered',
    ActiveCustomers: 'Active customers',
    ActiveHint: 'Ordered in the selected period',
    Inactive30: '30-day inactive',
    Inactive30Hint: 'Last order 31–60 days ago',
    Inactive60: '60-day inactive',
    Inactive60Hint: 'Last order 61–90 days ago',
    Dormant90: '90-day dormant',
    Dormant90Hint: 'No order for over 90 days',
    IncompleteRegistration: 'Incomplete registration',
    NoPhoneHint: 'No phone number on the account',
    RepeatCustomers: 'Repeat customers',
    RepeatHint: '2 or more orders',
    TopSpender: 'Top spender',
    SegmentOrdered30: 'Ordered ≤30 days',
    OrderedWithinDays: 'Ordered ≤{{count}} days',
    AllTime: 'All time',
    CouponUser: 'Coupon user',
    Referred: 'Referred',
    Credits: 'Credits',
    AllStores: 'All favourite stores',
    Missing: 'Missing',
    Spent: 'Spent',
    AvgOrder: 'Avg order',
    LastOrder: 'Last order',
    Joined: 'Joined',
    SavedAddress: 'saved address',
    Map: 'Map',
    FavouriteStore: 'Favourite store',
    Offers: 'Offers',
    On: 'On',
    Off: 'Off',
    LastNDays: 'Last {{count}} days',
    CustomRange: 'Custom range',
    SortNewest: 'Newest first',
    SortMostItems: 'Most items',
    SortFewestItems: 'Fewest items',
    ExportCSV: 'Export CSV',
    TopCustomersBySpend: 'Top customers by spend',
    TopStores: 'Top stores',
    TopProducts: 'Top products',
    TopSellersSubtitle: 'By delivered sales in this period',
    NoSalesInPeriod: 'No sales in this period',
    SoldCount: 'sold',
    TopCustomersSubtitle: 'Paid orders, net of refunds',
    NoPhone: 'No phone',
    CustomerLocations: 'Customer locations',
    CustomerLocationsSubtitle:
      'Postcode area of each customer’s latest delivery. Click to filter.',
    NoLocationsYet: 'No delivery addresses yet',
    SearchCustomers: 'Search name, phone, postcode…',
    ViewCustomers: 'Click to see these customers',
    ShowingBelow: 'Showing these customers below',
    DaysSinceOrder: 'Days since order'
  }
}

export default en
